import Model from '../Model/Model';
import DetailPanel from '../DetailPanel/DetailPanel';
import * as Map from '../Map/Map';
// import Tooltip from '../Tooltip/Tooltip';

var api = {
  go: function() {
    Model.load();
    DetailPanel.init();
    Map.init();
    // Tooltip.init();
  }
};

export default api;



/** WEBPACK FOOTER **
 ** ./src/App/App.js
 **/